/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NameInputSettings } from '../models/NameInputSettings';
import type { ObjectListSettings } from '../models/ObjectListSettings';
import type { ScanSettings } from '../models/ScanSettings';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SettingsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Scan Settings
     * @returns ScanSettings Successful Response
     * @throws ApiError
     */
    public getScanSettingsApiV1SettingsScanGet(): CancelablePromise<ScanSettings> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/settings/scan',
        });
    }
    /**
     * Set Scan Settings
     * @returns ScanSettings Successful Response
     * @throws ApiError
     */
    public setScanSettingsApiV1SettingsScanPut({
        requestBody,
    }: {
        requestBody: ScanSettings,
    }): CancelablePromise<ScanSettings> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/settings/scan',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Object List Settings
     * @returns ObjectListSettings Successful Response
     * @throws ApiError
     */
    public getObjectListSettingsApiV1SettingsObjectListGet(): CancelablePromise<ObjectListSettings> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/settings/object-list',
        });
    }
    /**
     * Set Object List Settings
     * @returns ObjectListSettings Successful Response
     * @throws ApiError
     */
    public setObjectListSettingsApiV1SettingsObjectListPut({
        requestBody,
    }: {
        requestBody: ObjectListSettings,
    }): CancelablePromise<ObjectListSettings> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/settings/object-list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Name Input Settings
     * @returns NameInputSettings Successful Response
     * @throws ApiError
     */
    public getNameInputSettingsApiV1SettingsNameInputGet(): CancelablePromise<NameInputSettings> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/settings/name-input',
        });
    }
    /**
     * Set Name Input Settings
     * @returns NameInputSettings Successful Response
     * @throws ApiError
     */
    public setNameInputSettingsApiV1SettingsNameInputPut({
        requestBody,
    }: {
        requestBody: NameInputSettings,
    }): CancelablePromise<NameInputSettings> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/settings/name-input',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
